module.exports = __webpack_public_path__ + "static/fanwood_text-webfont-0edc294e5f6ab61c2d844b1f8702d82d.woff";